<div class="pillar-card mat-elevation-z15">
  <div class="pillar-title">
    <h2
      class="pillar-sub-title siila-menu-color uppercase"
      translate="home.{{ currentCode }}.pillars.title"
    ></h2>
  </div>
  <div class="pillar-container">
    <div class="check-pillar" *ngFor="let check of pillarCheck">
      <div class="check-info">
        <h3 class="check-title" [translate]="check.title"></h3>
        <span class="check-sub-title" [translate]="check.desc"></span>
      </div>
    </div>
  </div>
</div>
